import { Box } from '@chakra-ui/react';
import { appendDisplayMagnitudePostfix } from '@lib/util/display-magnitude';
import { Field } from '@ui/components/Field';
import { DollarSignIcon } from '@ui/components/Icons';
import { selectQuoteBuilder } from '@ui/features/quote-builder/state/selectors/quote-builder';
import { selectQuotePrice } from '@ui/features/quote-builder/state/selectors/quote-price';
import { selectQuotePriceField } from '@ui/features/quote-builder/state/selectors/quote-price-field';
import { useSelector } from '@ui/hooks/useSelector';
import { currency } from '@ui/util/currency';

import { useQuotePriceContext } from './QuotePriceProvider';

export function UnitVariableCosts() {
  const displayQuantity = useSelector(
    (state) => selectQuoteBuilder(state).displayQuantity,
  );
  const { quoteLineUuid, quotePriceUuid, isFirstQuotePrice } =
    useQuotePriceContext();
  const { value } = useSelector((state) =>
    selectQuotePriceField(
      state,
      quoteLineUuid,
      quotePriceUuid,
      'unitVariableCosts',
    ),
  );

  const { unitLaborCost, unitMaterialCost, unitServiceCost } = useSelector(
    (state) => selectQuotePrice(state, quoteLineUuid, quotePriceUuid),
  );

  return (
    <Field
      label={appendDisplayMagnitudePostfix(
        'Unit Variable Costs',
        displayQuantity,
        '/',
      )}
      showLabel={isFirstQuotePrice}
      leftIcon={DollarSignIcon}
      value={value}
      type="number"
      isDisabled
    >
      <Box fontSize="sm" display="flex" px={2} justifyContent="space-between">
        <Box display="flex" flexDirection="column">
          <strong>Labor</strong>
          {currency(unitLaborCost)}
        </Box>
        <Box display="flex" flexDirection="column">
          <strong>Material</strong>
          {currency(unitMaterialCost)}
        </Box>
        <Box display="flex" flexDirection="column">
          <strong>Service</strong>
          {currency(unitServiceCost)}
        </Box>
      </Box>
    </Field>
  );
}
